import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({ description, lang, meta, title, thumbnail }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            defaultImage
            social {
              twitter
            }
            siteUrl
            ogCard
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  // const defaultImage = site.siteMetadata?.defaultImage
  const siteUrl = site.siteMetadata?.siteUrl
  const twitter = site.siteMetadata?.social.twitter
  const ogCard = site.siteMetadata?.ogCard

  const imagePath = thumbnail
    ? thumbnail.childImageSharp
      ? `${siteUrl}${thumbnail.childImageSharp?.gatsbyImageData?.images.fallback.src}`
      : `${siteUrl}${thumbnail}`
    : `${siteUrl}{defaultImage}`

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `og:image`,
          content: imagePath,
        },

        {
          name: `twitter:creator`,
          content: site.siteMetadata?.social?.twitter || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:site`,
          content: twitter,
        },
        {
          name: `twitter:card`,
          content: ogCard,
        },
        {
          name: `twitter:image`,
          content: imagePath,
        },
      ].concat(meta)}
    >
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6511226142017261"
        crossorigin="anonymous"
      ></script>
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `ja`,
  meta: [],
  description: ``,
  image: `/images/logo`,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default Seo
